export type SurveyConfig = {
  title: string;
  subtitle: string;
  q1: string;
  q2: string;
  q3: string;
  thanksTitle: string;
  thanksBody: string;
};

export const CSAT_L = [
  'Very dissatisfied',
  'Dissatisfied',
  'Neutral',
  'Satisfied',
  'Very satisfied',
];
